import get from 'lodash/get';

export default function isCreditCardFormFieldDisabled(fieldKey, formData) {
  if (get(formData, 'paymentOption', false)) {
    switch (fieldKey) {
      case 'cardNumber':
        return true;

      default:
        return false;
    }
  }

  return false;
}
